/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyUserMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyUser. */
export class FamilyUser {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyUser.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Graph APIs to return the metadata of the user's profile photo.
   * @summary Retrieves the metadata of the family member's profile photo.
   * @param puid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataResponse>
   */
  getFamilyMemberProfilePhotoMetadata(puid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataResponse>;
  /**
   * @param puid
   * @param callback The callback
   */
  getFamilyMemberProfilePhotoMetadata(puid: string, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  /**
   * @param puid
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyMemberProfilePhotoMetadata(puid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  getFamilyMemberProfilePhotoMetadata(puid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>, callback?: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataResponse> {
    return this.client.sendOperationRequest(
      {
        puid,
        options
      },
      getFamilyMemberProfilePhotoMetadataOperationSpec,
      callback) as Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataResponse>;
  }

  /**
   * Calls Graph APIs to return the metadata of the family member's profile photo for a given size.
   * @summary Retrieves the metadata of the family member's profile photo for a given size.
   * @param puid
   * @param photoSizeId
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataForSizeIdResponse>
   */
  getFamilyMemberProfilePhotoMetadataForSizeId(puid: string, photoSizeId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataForSizeIdResponse>;
  /**
   * @param puid
   * @param photoSizeId
   * @param callback The callback
   */
  getFamilyMemberProfilePhotoMetadataForSizeId(puid: string, photoSizeId: string, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  /**
   * @param puid
   * @param photoSizeId
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyMemberProfilePhotoMetadataForSizeId(puid: string, photoSizeId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  getFamilyMemberProfilePhotoMetadataForSizeId(puid: string, photoSizeId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>, callback?: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataForSizeIdResponse> {
    return this.client.sendOperationRequest(
      {
        puid,
        photoSizeId,
        options
      },
      getFamilyMemberProfilePhotoMetadataForSizeIdOperationSpec,
      callback) as Promise<Models.FamilyUserGetFamilyMemberProfilePhotoMetadataForSizeIdResponse>;
  }

  /**
   * Calls IDSAPI APIs to return the date of birth and age group of the user.
   * @summary Retrieves the age details of the current.
   * @param puid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyUserGetUserAgeDetailsResponse>
   */
  getUserAgeDetails(puid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyUserGetUserAgeDetailsResponse>;
  /**
   * @param puid
   * @param callback The callback
   */
  getUserAgeDetails(puid: string, callback: coreHttp.ServiceCallback<Models.UserAgeDetails>): void;
  /**
   * @param puid
   * @param options The optional parameters
   * @param callback The callback
   */
  getUserAgeDetails(puid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserAgeDetails>): void;
  getUserAgeDetails(puid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserAgeDetails>, callback?: coreHttp.ServiceCallback<Models.UserAgeDetails>): Promise<Models.FamilyUserGetUserAgeDetailsResponse> {
    return this.client.sendOperationRequest(
      {
        puid,
        options
      },
      getUserAgeDetailsOperationSpec,
      callback) as Promise<Models.FamilyUserGetUserAgeDetailsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getFamilyMemberProfilePhotoMetadataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/{puid}/photo",
  urlParameters: [
    Parameters.puid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UserProfilePhotoMetadata
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getFamilyMemberProfilePhotoMetadataForSizeIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/{puid}/photos/{photoSizeId}",
  urlParameters: [
    Parameters.puid,
    Parameters.photoSizeId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UserProfilePhotoMetadata
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUserAgeDetailsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family/{puid}/ageDetails",
  urlParameters: [
    Parameters.puid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UserAgeDetails
    },
    404: {
      bodyMapper: Mappers.UserAgeDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
